import React, { useState } from "react";
import DragAndDrop from "../components/DragAndDrop";
import FileUploadGrid from "../components/FileUploadGrid";
import { EntityProvider, useEntityContext } from "../context/EntityContext";
import { getDocMetaData } from "../utils/getDocMetaData";
import { DocMetaData } from "../utils/docMetaData";
import { toast } from "react-toastify";
import { Progress } from "@heroui/react";
import Banner from "../components/Banner";
import { UploadButton } from "../components/UploadButton";
import { useError } from "../context/ErrorContext";



const UploadPage: React.FC = () => {

    const [filesMeta, setFilesMeta] = useState<DocMetaData[]>([]);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const { entityMap } = useEntityContext();
     const { showError } = useError();
   
    // Called after files are selected or dropped   
    const handleFileSelected = async (selectedFiles: File[]) => {
        if (selectedFiles.length === 0) return;

        //Avoid duplicate file selection
        const existingNames = new Set(filesMeta.map(f => f.fileName));
        const uniqueFiles = selectedFiles.filter(file => !existingNames.has(file.name));
        if (uniqueFiles.length === 0) {
            toast.info("Selected files already exists in the grid.");
            return;
        }

        setLoading(true);
        setProgress(0);

        const total = uniqueFiles.length;
        let completed = 0;
        const tempMetaList: DocMetaData[] = [];

        const onProgress = (percent: number) => {
            //Smooth progress update
            setProgress(prev => (percent > prev ? percent : prev));
               
        };


        try {
            for (const file of uniqueFiles) {
                const isExcel = /\.(xlsx|xls)$/i.test(file.name);

                if (isExcel){
                    //Bypass the API call for metadata extraction for excel files
                    tempMetaList.push({
                        fileName: file.name,
                        documentType: "Finance Input",
                        entityType: "",
                        entity: "",
                        authorDate: "",
                        documentDate: "",
                        file,
                    });
                    completed += 1;
                    const percent = Math.round((completed / total) * 100);
                    onProgress(percent);
                    await new Promise(resolve => setTimeout(resolve, 100));
                } else {
                    //Use metadata extraction API
                    const metadata = await getDocMetaData([file], onProgress, false, showError);
                    tempMetaList.push(...metadata);
                    completed += 1;
    
                    //Ensure 100% update for smooth completion
                    const finalProgress = Math.round((completed / total) * 100);
                    setProgress(finalProgress);
    
                    //Optional short delay for smooth animation
                    await new Promise(resolve => setTimeout(resolve, 200));
                }
               
            }
            console.log("templist is", tempMetaList);
            // console.log("prev files meta is ", filesMeta)

            //Update grid with new data
            setFilesMeta(prev => [...prev, ...tempMetaList]);

            console.log("files meta is ", filesMeta)



        } catch (error) {
            toast.error(`Metadata extraction failed for one or more files`);
        } finally {
            //Briefly show 100% before hiding
            setTimeout(() => {
                setLoading(false);
                setProgress(0);
            }, 1000);
        }

        // console.log('tempMetalist', filesMeta)

    };


    return (

        <EntityProvider>
            <Banner current="upload" />

            <div data-testid="upload-page" className=" p-6 max-w-screen-xl mx-auto ">
                <h1 className="text-1xl font-bold text-start">Upload Documents</h1>
                <DragAndDrop onFilesSelected={handleFileSelected} loading = {loading} />

                {/* Metadata Progress Bar */}
                {loading && (
                    <div className="my-4">
                        <Progress
                            size="md"
                            radius="sm"
                            label="Extracting Metadata..."
                            value={progress}
                            maxValue={100}
                            color="secondary"
                            showValueLabel
                        />
                    </div>
                )}

                {/* Upload File Progress bar */}
                {uploading && (
                    <div className="my-4">
                        <Progress
                            size="md"
                            radius="sm"
                            label="Uploading Files..."
                            value={uploadProgress}
                            maxValue={100}
                            color="success"
                            showValueLabel
                        />
                    </div>
                )}
                
                <div className="mb-4 flex justify-end">
                    <UploadButton 
                        filesMeta={filesMeta}
                        entityMap={entityMap}
                        setFilesMeta={setFilesMeta}
                        uploading={uploading}
                        setUploading={setUploading}
                        setUploadProgress={setUploadProgress}
                        endpoint="/uploader/upload"
                        uploadMode="upload"
                        label="Upload"
                        />
                </div>

        
                        <div className="mt-4">
                    <FileUploadGrid rowData={filesMeta}
                        setRowData={setFilesMeta}
                    />
                </div>
                   
                
 
            </div>

        </EntityProvider>


    );

};


export default UploadPage;

